import { handleActions } from 'redux-actions';
import { PAGES } from './actions';

export const initialState = {
	stateCities: null,
};

export default handleActions({
	[PAGES.STATE_CITIES_REQUEST]: (state) => {
		return { ...state };
	},
	[PAGES.STATE_CITIES_SUCCESS]: (state, action) => {
		return {
			...state,
			stateCities: action.payload,
		};
	},
	[PAGES.STATE_CITIES_FAILURE]: (state) => {
		return {
			...state,
			stateCities: null,
		};
	},
}, initialState);